export const Terminal = 'terminal'
export const Pump = 'pump'
export const Premium = 'premium'
export const NFT = 'nft'

export type Platform =
  | typeof Terminal
  | typeof Pump
  | typeof Premium
  | typeof NFT
